import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import type { NavItem } from './Navbar'

interface DesktopNavProps {
  navItems: NavItem[]
  isActive: (path: string) => boolean
}

export function DesktopNav({ navItems, isActive }: DesktopNavProps) {
  return (
    <div className="hidden lg:flex items-center gap-1">
      {navItems.map((item) => {
        const Icon = item.icon
        const active = isActive(item.path)
        return (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "relative flex items-center gap-2.5 px-4 py-2.5 rounded-lg text-base font-medium transition-all duration-200",
              active
                ? "text-primary-700 bg-primary-100 dark:text-primary-400 dark:bg-primary-900/30"
                : item.danger
                  ? "text-red-700 hover:text-red-800 hover:bg-red-50 dark:text-red-400 dark:hover:text-red-300 dark:hover:bg-red-900/30"
                  : "text-neutral-700 hover:text-neutral-900 hover:bg-neutral-100 dark:text-neutral-300 dark:hover:text-neutral-100 dark:hover:bg-neutral-800"
            )}
          >
            <Icon className="h-5 w-5" />
            <span>{item.label}</span>
            {item.badge && (
              <span className="px-1.5 py-0.5 text-2xs bg-primary-600 text-white rounded font-semibold tracking-wide">
                {item.badge}
              </span>
            )}
            {/* Active indicator line */}
            {active && (
              <span className="absolute bottom-0 left-4 right-4 h-0.5 bg-primary-600 rounded-full" />
            )}
          </Link>
        )
      })}
    </div>
  )
}
